import React, { useEffect, useRef, useState } from "react";
import { Toast } from "../../Component/Toast";
import { post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import RawWebSocket from "../../Websocker/RawWebSocket";

const SINGLE_FALLBACK_MAX = 250;

export default function SingleDigitScreen({
  singleData,
  lotName,
  lotTime,
  slotId,
  userId,
}) {
  const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);
  const [rows, setRows] = useState([
    { id: 1, digit: "", amount: 1 },
    { id: 2, digit: "", amount: 1 },
    { id: 3, digit: "", amount: 1 },
  ]);

  const digitRefs = useRef([]);
  const amountRefs = useRef([]);

  // Use API max quantity; fall back to hardcoded if 0 or missing
  const maxQty =
    singleData?.maximum_quantity > 0
      ? singleData.maximum_quantity
      : SINGLE_FALLBACK_MAX;

  const increaseAmount = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const current = parseInt(newRows[index].amount || "0", 10);
      const nextVal = current + 1;
      newRows[index] = {
        ...newRows[index],
        amount: nextVal > maxQty ? String(maxQty) : String(nextVal),
      };
      return newRows;
    });
  };

  const decreaseAmount = (index) => {
    setRows((prev) => {
      const newRows = [...prev];
      const current = parseInt(newRows[index].amount || "0", 10);
      const nextVal = current > 0 ? current - 1 : 0;
      newRows[index] = {
        ...newRows[index],
        amount: String(nextVal),
      };
      return newRows;
    });
  };

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const viewport = window.visualViewport;
    if (!viewport) return;
    const handler = () => {
      setIsOpen(viewport.height < window.innerHeight);
    };
    viewport.addEventListener("resize", handler);
    return () => viewport.removeEventListener("resize", handler);
  }, []);

  const handleAdd = async (index) => {
    const row = rows[index];
    if (!row.digit) {
      Toast("Please enter a digit");
      return;
    }
    if (!row.amount || row.amount <= 0) {
      Toast("Please enter a valid count");
      return;
    }

    const addedValue = {
      ticket_amount: singleData?.digit_fee * row.amount,
      price: singleData?.digit_fee,
      lot_details:
        `${singleData?.fee_price_name} ${["A", "B", "C"][index]} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),

      count: parseInt(row.amount || "0", 10),
      my_number: row.digit,
      client_id: userId,
      fee_price_id: singleData?.fee_price_id,
      game_slot_id: slotId || null,
      type: singleData?.type,
      digit: ["A", "B", "C"][index],
      name: `${singleData?.fee_price_name} ${["A", "B", "C"][index]} ${lotName === "Kerala 3 PM" ? "KERALA" : "DEAR"} ${lotTime}`.toUpperCase(),
    };

    setRows((prev) => {
      const copy = [...prev];
      copy[index] = { digit: "", amount: 1 };
      return copy;
    });

    if (isKeyboardOpen && isOpen) {
      setTimeout(() => {
        digitRefs.current[index]?.focus();
      }, 100);
    }

    let payload = {
      user_id: userId,
      cart_item: [addedValue],
    };
    console.log("add via socket:", payload);
    RawWebSocket.emit("cart_add", payload);
  };

  const handleRandom = () => {
    setIsKeyboardOpen(false);
    setRows((prev) =>
      prev.map((r) => ({
        ...r,
        digit: String(Math.floor(Math.random() * 10)),
      })),
    );
  };

  return (
    <div className="sd-container">
      <div className="sd-card">
        <div className="sd-card-header">
          <div>
            <div className="sd-row">
              <div className="sd-card-title">{`${singleData?.fee_price_name?.replace(/[0-9]/g, "") || ""}${singleData?.fee_price_name ? " Win" : ""}`}</div>
              <div className="sd-price">{`₹${singleData?.price || ""}`}</div>
            </div>
            <div className="sd-row">
              <div className="sd-small">Buy price</div>
              <div className="sd-price">{`₹${singleData?.digit_fee || ""}`}</div>
            </div>
          </div>
          <div className="sd-random" onClick={handleRandom}>
            Random
          </div>
        </div>

        {["A", "B", "C"].map((label, index) => (
          <div className="sd-input-row" key={label}>
            <div className="sd-left">
              <div className="sd-ab">{label}</div>
              <input
                className="sd-digit"
                maxLength={1}
                inputMode="numeric"
                onFocus={() => setIsKeyboardOpen(true)}
                value={rows[index].digit}
                ref={(el) => (digitRefs.current[index] = el)}
                onChange={(e) => {
                  const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 1);
                  setRows((prev) => {
                    const copy = [...prev];
                    copy[index].digit = val;
                    return copy;
                  });
                  if (val)
                    setTimeout(() => amountRefs.current[index]?.focus(), 10);
                }}
              />
            </div>

            <div className="sd-right">
              <div className="sd-counter">
                <button type="button" onClick={() => decreaseAmount(index)}>
                  -
                </button>
                <input
                  ref={(el) => (amountRefs.current[index] = el)}
                  inputMode="numeric"
                  value={rows[index].amount}
                  onFocus={(e) => {
                    setIsKeyboardOpen(true);
                    e.target.select();
                  }}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[^0-9]/g, "");
                    const num = Math.min(Number(val || 0), maxQty);
                    setRows((prev) => {
                      const copy = [...prev];
                      copy[index].amount = num === 0 ? "" : num;
                      return copy;
                    });
                  }}
                  onKeyDown={(e) => {
                    const input = e.target;
                    if (
                      e.key === "Backspace" &&
                      input.selectionStart === 0 &&
                      input.selectionEnd === input.value.length
                    ) {
                      e.preventDefault();
                      setRows((prev) => {
                        const copy = [...prev];
                        copy[index].amount = "";
                        return copy;
                      });
                    }
                    if (e.key === "Backspace" && rows[index]?.amount === "") {
                      digitRefs.current[index]?.focus();
                    }
                  }}
                />
                <button type="button" onClick={() => increaseAmount(index)}>
                  +
                </button>
              </div>
              <button
                className="sd-add"
                type="button"
                onClick={() => handleAdd(index)}
              >
                ADD
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}